module.exports = __webpack_public_path__ + "media/img/frontend_application/banner_get_more-05350f3357cfee6e86ef975e5b0e38f8.jpg";